/**
 * CategoryCardsSkeleton - Loading state for category cards grid
 *
 * Mirrors the real card structure (image aspect-[5/6] + title strip) so the
 * layout doesn't shift when actual content arrives.
 */

import { Skeleton, useCategoryCardsVariants } from '../../../Theme'

export function CategoryCardsSkeleton() {
  const {
    categoryCardsGridVariants,
    categoryCardSkeletonVariants,
  } = useCategoryCardsVariants()

  return (
    <div
      className={categoryCardsGridVariants()}
      aria-busy="true"
      aria-label="Loading category cards"
    >
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className={categoryCardSkeletonVariants()}>
          <Skeleton className="aspect-[5/6] rounded-none" />
          <div className="py-3 px-2 flex justify-center">
            <Skeleton className="h-5 w-2/3" />
          </div>
        </div>
      ))}
    </div>
  )
}
